import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useWidgetSlotConfigurationByNameType } from '@/hooks/useWidgetConfigurationByOrganizationId';

import { LandPageLayout } from './components/LandPageLayout';

export const LandSocialPage = () => {
  const widgetSlotsConfiguration = useWidgetSlotConfigurationByNameType(
    DefaultWidgetNames.default_template_asset_social,
    WidgetType.t_page,
  );

  return (
    <LandPageLayout>
      <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
    </LandPageLayout>
  );
};
